export default {
  step1Title: "أخبرنا عن نشاطك",
  step1Desc: "سنستخدم نوع النشاط لتخصيص الحسابات والتوصيات المناسبة لك.",
  step2Title: "الطاقة الاستيعابية والتشغيل",
  step2Desc: "ساعدنا في فهم حجم عمليات الحجوزات اليومية وقيمة خدماتك.",
  step3Title: "عدم الحضور، الإلغاءات والمكالمات الضائعة",
  step3Desc: "أدخل تقديراتك لنسب عدم الحضور والإلغاء وتأثير المكالمات التي لم يتم الرد عليها.",
  step4Title: "توزيع المواعيد وفترات الذروة",
  step4Desc: "حلل أوقات الازدحام وفقدان العملاء نتيجة سوء التوزيع أو عدم توفر مواعيد فورية.",
  step5Title: "الإجازات والانقطاعات عن العمل",
  step5Desc: "احسب تأثير التوقفات السنوية أو الطارئة على حجز المواعيد ومستوى وعي العملاء بها.",
  step: "الخطوة",
  of: "من",
  serviceCategoryLabel: "الفئة الرئيسية للخدمة",
  catMedical: "طبي وصحي",
  catEducation: "تعليم وتدريب",
  catProfessional: "استشارات وخدمات مهنية",
  catField: "خدمات ميدانية وصيانة",
  catRental: "تأجير ومساحات",
  catLifestyle: "تجميل ورياضة وضيافة",
  serviceCategoryHelper: "اختر الفئة الأقرب لنشاطك، ثم ستظهر الخدمات المناسبة لها فقط.",
  serviceTypeLabel: "نوع الخدمة الفرعية",
  serviceTypeHelper: "تم تقليل الخيارات المعروضة بناءً على الفئة الرئيسية.",
  currencyLabel: "العملة",
  deliveryModeLabel: "طريقة تقديم الخدمة",
  modeCenter: "في المركز / الفرع",
  modeOnline: "أونلاين",
  modeClient: "في موقع العميل",
  deliveryModeHelper: "يمكن اختيار أكثر من طريقة.",
  complexityLabel: "هل لديك أكثر من فرع أو مقدم خدمة؟",
  compNone: "لا",
  compProviders: "نعم، أكثر من مقدم خدمة",
  compBranches: "نعم، أكثر من فرع",
  compBoth: "نعم، فروع ومقدمو خدمة",
  dailyBookingsLabel: "متوسط عدد الحجوزات اليومية الحالية",
  dailyBookingsHelper: "أدخل متوسط الحجوزات التي تتم فعلياً يومياً.",
  avgValueLabel: "متوسط قيمة الحجز الواحد",
  avgValueHelper: "متوسط تقريبي لقيمة الحجز.",
  workingDaysLabel: "عدد أيام العمل شهرياً",
  workingDaysHelper: "مثلاً 26 يوم عمل شهرياً.",
  avgDurationLabel: "متوسط مدة الحجز",
  minutes: "دقيقة",
  avgDurationHelper: "يساعد ذلك على تقدير الطاقة الاستيعابية اليومية.",
  resourceCountLabel: "عدد مقدمي الخدمة أو الموارد المتاحة",
  resourceCountHelper: "أطباء، مدربون، غرف...",
  workingHoursLabel: "عدد ساعات العمل اليومية",
  workingHoursHelper: "لتقدير الطاقة القصوى اليومية.",
  expectedRevenue: "الإيراد المتوقع من الحجوزات الحالية",
  noShowRateLabel: "نسبة عدم الحضور",
  cancelRateLabel: "نسبة الإلغاءات",
  compensatedCancelRateLabel: "نسبة الإلغاءات المعوضة",
  missedCallsLabel: "فرص ضائعة يومياً بسبب عدم الرد",
  callConversionRateLabel: "نسبة التحويل للحجوزات",
  step4Info: "أحياناً المشكلة في سوء التوزيع.",
  peakLostBookingsLabel: "كم عميل يغادر دون حجز وقت الذروة؟",
  redistributionRateLabel: "نسبة يمكن تحويلها لوقت آخر",
  idleTimesLabel: "هل لديك أوقات فراغ واضحة؟",
  idleDaily: "نعم، يومياً",
  idleSometimes: "أحياناً",
  idleRarely: "نادراً",
  idleUnknown: "لا أعرف",
  step5Info: "لا تُحسب أيام الانقطاع كخسارة إذا عُرفت مسبقاً.",
  annualLeaveDaysLabel: "أيام الإجازة السنوية",
  officialHolidayDaysLabel: "أيام الإجازات الرسمية",
  eventDaysLabel: "أيام الفعاليات",
  emergencyDaysLabel: "انقطاع طارئ",
  affectedOppLabel: "فرص متأثرة في كل يوم انقطاع",
  communicationLevelLabel: "إعلام العملاء بالانقطاع مسبقاً؟",
  commClear: "نعم بوضوح",
  commSometimes: "أحياناً",
  commNo: "لا",
  commNone: "لا يوجد نظام",
  availabilityAlternativeRateLabel: "نسبة التحويل لموعد بديل",
  totalUnavailableDays: "إجمالي أيام الانقطاع السنوية",
  days: "يوم",
  prev: "السابق",
  next: "التالي",
  showResults: "عرض النتائج",
  liveSummary: "ملخص مباشر",
  expectedMonthlyBookings: "الحجوزات الشهرية المتوقعة",
  booking: "حجز",
  monthlyLoss: "الفرص غير المستغلة شهرياً",
  avgUnavailableDays: "متوسط أيام الانقطاع شهرياً",
  resultTitle: "نتيجتك التقديرية",
  resultDesc: "بناءً على البيانات التي أدخلتها، هذه تقديرات تقريبية لحجم الإيرادات التي قد تضيع بسبب مشاكل إدارة الحجوزات.",
  totalMonthlyLoss: "إجمالي الفرص المالية غير المستغلة شهرياً",
  potentialEst: "تقدير محتمل",
  confirmedLosses: "خسائر من حجوزات مؤكدة",
  noShowAndCancel: "No-show + إلغاء غير معوض",
  growthOpportunities: "فرص حجز ونمو ضائعة",
  outsideRevenue: "فرص خارج الإيراد الحالي",
  recoverableRevenue: "إيراد يمكن تحسينه جزئياً",
  notFullyGuaranteed: "غير مضمون بالكامل",
  annualPotentialValue: "القيمة السنوية المحتملة",
  monthlyLossBookings: "الفرص غير المستغلة شهرياً",
  dailyCapacity: "الطاقة الاستيعابية اليومية",
  annualAvailabilityLoss: "أثر الانقطاعات سنوياً",
  totalUnavailableDaysAnnual: "أيام الانقطاع السنوية",
  lossBreakdownTitle: "تفصيل الفرص المالية غير المستغلة",
  category: "التصنيف",
  source: "المصدر",
  monthlyOpportunities: "عدد الفرص شهرياً",
  monthlyValue: "القيمة الشهرية",
  lossComparisonTitle: "مقارنة مصادر الفرص غير المستغلة",
  riskIndicatorsTitle: "مؤشرات الخطورة التشغيلية",
  confirmedRiskPercent: "فرص الحجوزات غير المستغلة المؤكدة",
  confirmedRiskDesc: "يقيس تأثير عدم الحضور والإلغاءات غير المعوضة على الإيراد الحالي.",
  growthRiskPercent: "فرص النمو الضائعة",
  growthRiskDesc: "يقيس قيمة الفرص التي لم تتحول إلى حجوزات مقارنة بالإيراد الحالي.",
  riskDisclaimer: "هذه الأرقام تقديرية، الهدف منها تحديد أماكن التحسين.",
  biggestSourceBadge: "أكبر مصدر للفرص غير المستغلة",
  yourMainProblem: "مشكلتك الرئيسية",
  exportPdf: "تصدير التقرير PDF",
  requestRecsBtn: "اطلب توصيات وحلول",
  ctaTitle: "حوّل الحجوزات الضائعة إلى إيرادات فعلية",
  ctaDesc: "تطبيق الحجوزات من سبلينداب يساعدك على تنظيم المواعيد وتقليل عدم الحضور.",
  talkToConsultant: "تحدث مع مستشار",
  feat1: "حجز مباشر من التطبيق",
  feat2: "تذكيرات آلية",
  feat3: "إدارة الإلغاء",
  feat4: "توزيع أفضل للمواعيد",
  feat5: "لوحة تحكم",
  feat6: "باقات واشتراكات",
  leadTitle: "اطلب توصيات وحلول لهذه الخسائر",
  leadDesc: "أدخل بياناتك ليصلك ملف التوصيات العامة على بريدك.",
  name: "الاسم",
  nameHolder: "اكتب اسمك",
  businessName: "اسم النشاط",
  businessNameHolder: "مثال: عيادة النور",
  whatsapp: "رقم واتساب",
  email: "البريد الإلكتروني",
  country: "الدولة",
  timeline: "متى تريد البدء؟",
  submitLead: "اطلب التوصيات والحلول",
  downloadGeneralPdf: "تحميل ملف التوصيات العامة PDF",
  leadSuccessDemo: "تمت العملية بنجاح. Lead Score: ",
  leadSuccessReal: "تم استقبال طلبك بنجاح!",
  leadError: "عذراً، خطأ: "
};
